var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Anicss',{attrs:{"enter-active-class":['animated', 'fadeIn'],"leave-active-class":['animated', 'fadeOut']}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }